import Brand from '@/services/Brand';

export default {
     state: {
          brand: null,
     },
     getters: {
          brand: state => state.brand,
     },
     mutations: {
          setBrand: (state, brand) => {
               state.brand = brand;
          },
     },
     actions: {
          setupBrand: (context, payload) => {
               const brand = Brand.getBrand();

               context.commit('setBrand', brand);
          },
     },
};
